import { CSSObject } from '@emotion/react';
import { TypographyVariants, Variant } from '../typography.types';

export const variantStyles: Record<Variant, CSSObject> = {
  [TypographyVariants.H1_SEMIBOLD]: {
    fontSize: '96px',
    fontWeight: 600,
    letterSpacing: '-1.5px',
    lineHeight: '100%',
  },
  [TypographyVariants.H2_SEMIBOLD]: {
    fontSize: '44px',
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.H3_SEMIBOLD]: {
    fontSize: '34px',
    fontWeight: 600,
    letterSpacing: '0.25px',
    lineHeight: '100%',
  },
  [TypographyVariants.H4_SEMIBOLD]: {
    fontSize: '28px',
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.H5_SEMIBOLD]: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.H6_SEMIBOLD]: {
    fontSize: '22px',
    fontWeight: 600,
    letterSpacing: '0.25px',
    lineHeight: '100%',
  },
  [TypographyVariants.H7_SEMIBOLD]: {
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.H8_MEDIUM]: {
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.H8_SEMIBOLD]: {
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.H8_5_REGULAR]: {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY1_LIGHT]: {
    fontSize: '14px',
    fontWeight: 300,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY1_5_LIGHT]: {
    fontSize: '14px',
    fontWeight: 300,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY1_REGULAR]: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.25px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY1_5_REGULAR]: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.25px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY1_MEDIUM]: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY1_5_MEDIUM]: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY1_SEMIBOLD]: {
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0.25px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY2_LIGHT]: {
    fontSize: '12px',
    fontWeight: 300,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY2_5_LIGHT]: {
    fontSize: '12px',
    fontWeight: 300,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY2_REGULAR]: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.17px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY2_5_REGULAR]: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY2_MEDIUM]: {
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY2_5_MEDIUM]: {
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY2_SEMIBOLD]: {
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.17px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY2_BOLD]: {
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.17px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY3_REGULAR]: {
    fontSize: '10px',
    fontWeight: 400,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY3_5_REGULAR]: {
    fontSize: '10px',
    fontWeight: 400,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY3_MEDIUM]: {
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.BODY3_5_MEDIUM]: {
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '0px',
    lineHeight: '150%',
  },
  [TypographyVariants.BODY3_SEMIBOLD]: {
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '100%',
  },
  [TypographyVariants.OVERLINE1_REGULAR]: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '1px',
    lineHeight: '100%',
    fontFamily: 'Open Sans, sans-serif',
    textTransform: 'uppercase',
  },
};
